// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"88121efb","231":"441d22ee","276":"6d59a05b","305":"a5583c9f","316":"9be6c326","478":"15500f00","624":"4d25b19a","704":"da2901c1","783":"3b52681e","876":"593414d4","949":"99ccae2c","951":"3ae96d1a"}[chunkId] + ".chunk.js";
};